import { render, staticRenderFns } from "./WkFormItem.vue?vue&type=template&id=217955f8&scoped=true"
import script from "./WkFormItem.vue?vue&type=script&lang=js"
export * from "./WkFormItem.vue?vue&type=script&lang=js"
import style0 from "./WkFormItem.vue?vue&type=style&index=0&id=217955f8&lang=scss"
import style1 from "./WkFormItem.vue?vue&type=style&index=1&id=217955f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217955f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217955f8')) {
      api.createRecord('217955f8', component.options)
    } else {
      api.reload('217955f8', component.options)
    }
    module.hot.accept("./WkFormItem.vue?vue&type=template&id=217955f8&scoped=true", function () {
      api.rerender('217955f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkForm/WkFormItem.vue"
export default component.exports